export const pl = {
  title: 'Dodawanie gazetek',
  summary: 'W toku: {active} · Wymaga uwagi: {attention}',
  collapse: 'Zwiń postęp dodawania',
  retry: 'Ponów etap',
  checkStatus: 'Sprawdź ponownie',
  edit: 'Popraw dane',
  resume: 'Zapisz i wznów',
  dismiss: 'Usuń wpis',
  dismissConfirm:
    'Usunąć wpis z historii? Gazetka pozostanie na serwerze. Trwające przetwarzanie nie zostanie anulowane.',
  cannotStart: 'Nie udało się uruchomić operacji w tle. Dane formularza zostały zachowane.',
  storageError:
    'Nie można zapisać postępu w tej przeglądarce. Sprawdź dostępne miejsce i ustawienia pamięci strony, a następnie odśwież panel.',
  needsAttention: 'Gazetka {name} wymaga uwagi.',
  completed: 'Dodawanie gazetki {name} zakończone.',
  states: {
    queued: 'Oczekuje na rozpoczęcie',
    running: 'Przetwarzanie',
    generating: 'Generowanie obrazów',
    attention: 'Wymaga uwagi',
    files: 'Wymaga plików',
    unknown: 'Wynik niepotwierdzony',
    done: 'Gotowe'
  },
  steps: {
    create: 'Tworzenie gazetki',
    update: 'Zapisywanie poprawek',
    upload: 'Wysyłanie stron',
    generate: 'Generowanie obrazów',
    cover: 'Wysyłanie okładki',
    schedule: 'Planowanie zmian linków',
    finish: 'Kończenie dodawania'
  },
  errors: {
    operationContextChanged: 'Zmieniono konto lub kraj. Wróć do poprzedniego kontekstu, aby wznowić operację.',
    statusUnavailable: 'Nie udało się odczytać aktualnego statusu. Przetwarzanie na serwerze może nadal trwać.',
    createUnconfirmed: 'Nie potwierdzono utworzenia gazetki. Sprawdź ponownie za chwilę; serwer może nadal pracować.',
    uploadUnconfirmed:
      'Serwer nie potwierdził przyjęcia plików. Ponownie sprawdź status przed następną próbą wysyłania.',
    generationFailed: 'Generowanie obrazów nie powiodło się.',
    filesRequired: 'Wskaż brakujące pliki przez „Popraw dane”.',
    locksUnavailable:
      'Ta przeglądarka nie obsługuje bezpiecznego wykonywania operacji w tle. Użyj aktualnej przeglądarki przez HTTPS.',
    scheduledTimePassed: 'Termin zaplanowanej zmiany już minął. Sprawdź efekt i popraw termin przez „Popraw dane”.',
    operationBusy: 'Operacja jest już wykonywana w innej karcie.',
    creationContextUnavailable: 'Zaloguj się ponownie przed rozpoczęciem dodawania.'
  }
}

export const en = {
  title: 'Adding leaflets',
  summary: 'In progress: {active} · Needs attention: {attention}',
  collapse: 'Collapse upload progress',
  retry: 'Retry step',
  checkStatus: 'Check again',
  edit: 'Edit details',
  resume: 'Save and resume',
  dismiss: 'Remove entry',
  dismissConfirm: 'Remove this history entry? The leaflet stays on the server. Processing will not be cancelled.',
  cannotStart: 'Could not start the background operation. Your form data has been kept.',
  storageError:
    'Progress cannot be saved in this browser. Check available space and site storage settings, then reload the panel.',
  needsAttention: 'Leaflet {name} needs attention.',
  completed: 'Leaflet {name} has been added.',
  states: {
    queued: 'Waiting to start',
    running: 'Processing',
    generating: 'Generating images',
    attention: 'Needs attention',
    files: 'Files required',
    unknown: 'Result unconfirmed',
    done: 'Done'
  },
  steps: {
    create: 'Creating leaflet',
    update: 'Saving changes',
    upload: 'Uploading pages',
    generate: 'Generating images',
    cover: 'Uploading cover',
    schedule: 'Scheduling link changes',
    finish: 'Finishing leaflet setup'
  },
  errors: {
    operationContextChanged: 'The account or country changed. Return to the original context to resume this operation.',
    statusUnavailable: 'Could not read the current status. Processing may still be running on the server.',
    createUnconfirmed: 'Creation has not been confirmed. Check again shortly; the server may still be working.',
    uploadUnconfirmed:
      'The server has not confirmed receipt of the files. Check the status again before another upload.',
    generationFailed: 'Image generation failed.',
    filesRequired: 'Select the missing files using “Edit details”.',
    locksUnavailable: 'This browser cannot safely run background operations. Use an up-to-date browser over HTTPS.',
    scheduledTimePassed: 'The scheduled time has passed. Check the result and change the time using “Edit details”.',
    operationBusy: 'This operation is already running in another tab.',
    creationContextUnavailable: 'Sign in again before adding leaflets.'
  }
}

export const ru = {
  title: 'Добавление листовок',
  summary: 'В работе: {active} · Требуют внимания: {attention}',
  collapse: 'Свернуть ход добавления',
  retry: 'Повторить этап',
  checkStatus: 'Проверить снова',
  edit: 'Изменить данные',
  resume: 'Сохранить и продолжить',
  dismiss: 'Удалить запись',
  dismissConfirm: 'Удалить запись из истории? Листовка останется на сервере. Обработка не будет отменена.',
  cannotStart: 'Не удалось запустить фоновую операцию. Данные формы сохранены.',
  storageError:
    'Не удалось сохранить ход операции в браузере. Проверьте свободное место и настройки хранения сайта, затем обновите панель.',
  needsAttention: 'Листовка {name} требует внимания.',
  completed: 'Добавление листовки {name} завершено.',
  states: {
    queued: 'Ожидает начала',
    running: 'Обработка',
    generating: 'Создание изображений',
    attention: 'Требует внимания',
    files: 'Требуются файлы',
    unknown: 'Результат не подтверждён',
    done: 'Готово'
  },
  steps: {
    create: 'Создание листовки',
    update: 'Сохранение изменений',
    upload: 'Загрузка страниц',
    generate: 'Создание изображений',
    cover: 'Загрузка обложки',
    schedule: 'Планирование изменений ссылок',
    finish: 'Завершение добавления'
  },
  errors: {
    operationContextChanged: 'Учётная запись или страна изменена. Вернитесь к исходному контексту для продолжения.',
    statusUnavailable: 'Не удалось получить текущий статус. Обработка на сервере может продолжаться.',
    createUnconfirmed: 'Создание не подтверждено. Проверьте позже: сервер может продолжать работу.',
    uploadUnconfirmed: 'Сервер не подтвердил получение файлов. Проверьте статус перед повторной загрузкой.',
    generationFailed: 'Не удалось создать изображения.',
    filesRequired: 'Выберите недостающие файлы через «Изменить данные».',
    locksUnavailable: 'Браузер не поддерживает безопасную фоновую работу. Используйте современный браузер через HTTPS.',
    scheduledTimePassed: 'Запланированное время прошло. Проверьте результат и измените время через «Изменить данные».',
    operationBusy: 'Операция уже выполняется в другой вкладке.',
    creationContextUnavailable: 'Войдите снова перед добавлением листовок.'
  }
}
